import React from "react";

import { Typography } from "@material-ui/core";

import Navigation from "../Navigation";
import { PHIAllowListContainer } from "./PHIAllowListContainer";

const PHIAllowListPageHeader: React.FC = () => {
  return (
    <>
      <Typography component="h2" gutterBottom variant="overline">
        HIPAA Allow List
      </Typography>
      <Typography component="h1" gutterBottom variant="h3">
        Send non-PHI Properties to your non-HIPAA destinations.
      </Typography>
    </>
  );
};

const PHIAllowListPage: React.FC = () => {
  return (
    <Navigation className="pt-6 h-full flex flex-col">
      <PHIAllowListPageHeader />
      <PHIAllowListContainer />
    </Navigation>
  );
};

export default PHIAllowListPage;
